import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button, Card } from "./index";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            padding: "2rem",
          }}
        >
          <Card>
            <h2 style={{ margin: "0 0 0.5rem" }}>Something went wrong</h2>
            <p style={{ color: "var(--c-text-muted)", margin: "0 0 1rem" }}>
              An unexpected error occurred. Try refreshing or click the button below.
            </p>
            {this.state.error && (
              <pre
                style={{
                  fontSize: "0.75rem",
                  background: "var(--c-bg-alt)",
                  padding: "0.75rem",
                  borderRadius: "0.375rem",
                  overflow: "auto",
                  maxHeight: "8rem",
                  margin: "0 0 1rem",
                }}
              >
                {this.state.error.message}
              </pre>
            )}
            <Button onClick={this.handleRetry}>Try Again</Button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}
